/**
 * Header Component
 * 
 * Application header with logo, notification bell, and user menu.
 * Used in the store layout for admin users.
 */

import React from "react";
import "./header.scss";
import { Layout, Dropdown } from "antd";
import logo from "../../../assets/images/logo.svg";
import { Avatar } from "primereact/avatar";
import avatarImg from "../../../assets/images/avatar.jpg";
import dropdownarrow from "../../../assets/images/dropdown-arrow.svg";
import { handleLogout } from "../../../services/auth";
import NotificationBell from "../../../Components/NotificationBell/NotificationBell";

const { Header } = Layout;

// User dropdown menu items
const items = [
  {
    key: '1',
    label: (
      <div onClick={() => handleLogout()}>
        Logout
      </div>
    ),
  }
];

export const CustomHeader = () => {
  return (
    <Header className="header-section flex align-items-center justify-content-between">
      <img src={logo} alt="logo" />
      <div className="right-side flex align-items-center gap-5">
        {/* Notification Bell with dropdown - replaces placeholder */}
        <div className="notification-section">
          <NotificationBell />
        </div>
        
        {/* User Menu Dropdown */}
        <div style={{cursor: "pointer"}}>
          <Dropdown menu={{ items }}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#!" onClick={(e) => e.preventDefault()} className="custom-dropdown-trigger user-section flex gap-2">
              <Avatar image={avatarImg} shape="circle" />
              <img src={dropdownarrow} alt="dropdown-arrow" />
            </a>
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};
